// extracted by mini-css-extract-plugin
export default {"AppLink":"AppLink_AppLink__1wXw9"};